import React, { Fragment, memo, useEffect } from "react";
import { Grid, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import InputField from "Components/formControls/HookFields/InputFieldWithIcon";
import { LinkedIn, Twitter, Facebook, Instagram } from "@material-ui/icons";
import { get } from "lodash";
import { isValidURL } from "src/utils";
import { useTargetValidation } from "Validations/target/useTargetValidation";
import useStyles from "../styles";

const SocialMediaLink = memo(() => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    register,
    watch,
    setError,
    formState: { errors }
  } = useFormContext();
  const { information, disabledView } = watch();
  const { pasteLinkError } = useTargetValidation();

  useEffect(() => {
    if (!isValidURL(information?.linkedInUrl) && information?.linkedInUrl) {
      setError(`information.linkedInUrl`, pasteLinkError);
      return;
    } else if (
      !isValidURL(information?.facebookUrl) &&
      information?.facebookUrl
    ) {
      setError(`information.facebookUrl`, pasteLinkError);
      return;
    } else if (
      !isValidURL(information?.twitterUrl) &&
      information?.twitterUrl
    ) {
      setError(`information.twitterUrl`, pasteLinkError);
      return;
    } else if (
      !isValidURL(information?.instagramUrl) &&
      information?.instagramUrl
    ) {
      setError(`information.instagramUrl`, pasteLinkError);
      return;
    }
  }, [
    information?.linkedInUrl,
    information?.instagramUrl,
    information?.facebookUrl,
    information?.twitterUrl
  ]);
  return (
    <Fragment>
      <Grid item xs={12} className={classes.resetSpacingSocialMedia}>
        <Typography variant="subtitle2" className="font-bold">
          {t("companySetup.information.socialLinks.socialLinksHeader")}
          <span className="f-gray font-12 font-regular">
            {t("text.optional")}
          </span>
        </Typography>
      </Grid>
      {/* <TopStrengths /> */}
      <Grid item xs={12} sm={6} className={classes.socialMedia}>
        <InputField
          register={register("information.linkedInUrl")}
          name="information.linkedInUrl"
          iconPosition="start"
          label={t("companySetup.information.socialLinks.linkedIn.label")}
          placeholder={t(
            "companySetup.information.socialLinks.linkedIn.placeholder"
          )}
          icon={LinkedIn}
          value={get(information, "linkedInUrl", "").trimLeft()}
          error={get(errors, "information.linkedInUrl.message", "")}
          disabled={disabledView}
        />
      </Grid>
      <Grid item xs={12} sm={6} className={classes.socialMedia}>
        <InputField
          register={register("information.facebookUrl")}
          name="information.facebookUrl"
          iconPosition="start"
          label={t("companySetup.information.socialLinks.facebook.label")}
          placeholder={t(
            "companySetup.information.socialLinks.facebook.placeholder"
          )}
          icon={Facebook}
          value={get(information, "facebookUrl", "").trimLeft()}
          error={get(errors, "information.facebookUrl.message", "")}
          disabled={disabledView}
        />
      </Grid>
      <Grid item xs={12} sm={6} className={classes.socialMedia}>
        <InputField
          register={register("information.twitterUrl")}
          name="information.twitterUrl"
          iconPosition="start"
          label={t("companySetup.information.socialLinks.twitter.label")}
          placeholder={t(
            "companySetup.information.socialLinks.twitter.placeholder"
          )}
          icon={Twitter}
          value={get(information, "twitterUrl", "").trimLeft()}
          error={get(errors, "information.twitterUrl.message", "")}
          disabled={disabledView}
        />
      </Grid>
      <Grid item xs={12} sm={6} className={classes.socialMedia}>
        <InputField
          register={register("information.instagramUrl")}
          name="information.instagramUrl"
          iconPosition="start"
          label={t("companySetup.information.socialLinks.instagram.label")}
          placeholder={t(
            "companySetup.information.socialLinks.instagram.placeholder"
          )}
          icon={Instagram}
          value={get(information, "instagramUrl", "").trimLeft()}
          error={get(errors, "information.instagramUrl.message", "")}
          disabled={disabledView}
        />
      </Grid>
    </Fragment>
  );
});

export default SocialMediaLink;
